import React, { useRef, useState } from 'react';
import { QRCodeCanvas } from 'qrcode.react';
import { X, Download, Copy, Check } from 'lucide-react';
import { toast } from 'sonner';

export default function QRModal({ event, onClose }) {
  const [copied, setCopied] = useState(false);
  const canvasRef = useRef(null);
  const registrationUrl = `${window.location.origin}/registro/${event.id}`;

  const copyUrl = async () => {
    await navigator.clipboard.writeText(registrationUrl);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
    toast.success('Link copiado');
  };

  const downloadQR = () => {
    const canvas = document.getElementById('soem-qr-canvas');
    if (!canvas) return;
    const url = canvas.toDataURL('image/png');
    const a = document.createElement('a');
    a.href = url;
    a.download = `qr-personal-${event.event_code || event.id.slice(0, 8)}.png`;
    a.click();
  };

  return (
    <div className="fixed inset-0 z-50 bg-black/70 flex items-center justify-center p-4">
      <div className="bg-white rounded-sm shadow-2xl w-full max-w-sm animate-fade-in">
        <div className="flex items-center justify-between px-5 py-4 border-b bg-soem-navy">
          <h3 className="font-bold text-white">QR de Auto-registro</h3>
          <button aria-label="Cerrar modal QR" onClick={onClose}><X size={18} className="text-slate-400 hover:text-white" /></button>
        </div>
        <div className="p-5 space-y-4">
          <p className="text-slate-500 text-xs text-center">
            El personal puede escanear este QR para registrarse en <strong>{event.name}</strong>
          </p>

          {/* QR Code */}
          <div className="flex justify-center p-4 bg-white border-4 border-soem-primary rounded-sm">
            <QRCodeCanvas
              id="soem-qr-canvas"
              value={registrationUrl}
              size={200}
              level="H"
              includeMargin
              imageSettings={{
                src: '',
                height: 0,
                width: 0,
                excavate: false,
              }}
            />
          </div>

          {/* URL */}
          <div className="flex items-center gap-2 bg-slate-50 border border-slate-200 rounded-sm px-3 py-2">
            <span className="text-xs text-slate-500 flex-1 truncate font-mono">{registrationUrl}</span>
            <button onClick={copyUrl} className="text-soem-primary flex-shrink-0">
              {copied ? <Check size={15} className="text-green-600" /> : <Copy size={15} />}
            </button>
          </div>

          {/* Actions */}
          <div className="grid grid-cols-2 gap-2">
            <button onClick={downloadQR} className="soem-btn-primary py-2.5 text-xs flex items-center justify-center gap-2" data-testid="download-qr-btn">
              <Download size={13} /> Descargar PNG
            </button>
            <button onClick={() => window.print()} className="soem-btn-secondary py-2.5 text-xs flex items-center justify-center gap-2">
              🖨 Imprimir QR
            </button>
          </div>

          {/* Instructions */}
          <div className="bg-blue-50 border border-blue-100 rounded-sm p-3 space-y-1">
            <p className="text-xs font-bold text-blue-800 mb-2">Instrucciones de uso:</p>
            {['Imprime este código QR', 'Colócalo en el punto de registro del evento', 'El personal lo escanea con su celular', 'Llena el formulario con sus datos', 'Recibirás una notificación por cada registro'].map((s, i) => (
              <p key={i} className="text-xs text-blue-700">{i + 1}. {s}</p>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
